import { Navigate } from 'react-router-dom';

export default function DaDashboard() {
  // Rediriger vers le nouveau dashboard du directeur
  return <Navigate to="/directeur" replace />;
}
